// Module
var code = `<!-- clCardGrid — grid of link cards for landing/navigation surfaces.
     Data shape: { items: [ { title, description, href, icon? }, ... ] }
     Each card is a single anchor wrapping its content. -->
<div class="block-cl-card-grid">
  {{#items}}
  <a class="block-cl-card-grid__card" data-channel="ROUTE" data-item-id="docs-{{stage}}" data-is-menu-link="true"  data-event-prevent-default="true" data-page-id="{{pageId}}" data-stage="{{stage}}" data-code-block-id="define" data-method-name="codeplaygroundAttr\$Default" data-code-block-data-section="types"  href="{{href}}">
    {{#icon}}<div class="block-cl-card-grid__icon block-cl-card-grid__icon--{{icon}}" aria-hidden="true"></div>{{/icon}}
    <div class="block-cl-card-grid__title">{{title}}</div>
    <div class="block-cl-card-grid__description">{{description}}</div>
  </a>
  {{/items}}
</div>
`;
// Exports
module.exports = code;